
export const GrantTypes = {
  NAVIGATION_ROVER_PROCESSING_LIMIT: 'navigation_rover_processing_limit',
  LIDAR_PROCESSING: 'lidar_processing',
  FILE_DOWNLOADING: 'file_downloading',
  JOB_PRIORITY: 'job_priority',
  HOSTING: 'hosting',
  FILE_STORAGE: 'file_storage',
}

export const GrantTypesOptions = [
  GrantTypes.NAVIGATION_ROVER_PROCESSING_LIMIT,
  GrantTypes.LIDAR_PROCESSING,
  GrantTypes.FILE_DOWNLOADING,
  GrantTypes.JOB_PRIORITY,
]

export const GrantOptions = {
  [GrantTypes.NAVIGATION_ROVER_PROCESSING_LIMIT]: {
    min: -1,
  },
  [GrantTypes.LIDAR_PROCESSING]: {
    min: -1,
  },
  [GrantTypes.FILE_DOWNLOADING]: {
    min: -1,
  },
  [GrantTypes.JOB_PRIORITY]: {
    min: 0,
    max: 10,
  },
}

export const GrantValuesMap = {
  '-1': 'Unlimited',
  '0': 'Denied',
}

export const MapGrantValueTypeToGrantValue = {
  'unlimited': -1,
  'denied': 0,
}

// Default values to set
export const GrantTypesValues = {
  [GrantTypes.NAVIGATION_ROVER_PROCESSING_LIMIT]: 3,
  [GrantTypes.LIDAR_PROCESSING]: 1,
  [GrantTypes.FILE_DOWNLOADING]: 1,
  [GrantTypes.JOB_PRIORITY]: 5,
}

export function convertRawGrant (raw) {
  const {
    user_id: userId,
    type_grant: grantType,
    value,
    start_date,
    end_date,
    created,
  } = raw
  return {
    userId,
    grantType: grantType && grantType.id,
    value,
    startDate: new Date(start_date),
    endDate: new Date(end_date),
    created: new Date(created),
  }
}

export function grantToRaw (raw) {
  const {
    userId: user_id,
    grantType: grant_type,
    value,
    startDate,
    endDate,
  } = raw
  return {
    user_id,
    type_grant: grant_type ? { id: grant_type } : null,
    value,
    start_date: startDate.toISOString(),
    end_date: endDate.toISOString(),
  }
}
